export const sum = arr => arr.reduce((acc, n) => acc + n, 0);
